import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { SemanticColor, semanticColors } from '../../theme/colors';
import { ErrorAnimationView } from './ErrorAnimationView';

export const ErrorAnimation: React.FC<TWidgetProps<TCommonData>> = ({ widget }) => {
    return <ErrorAnimationView uid={widget.uid} margin={widget.options?.margin} animationsColor={semanticColors[SemanticColor.IconError]} />;
};
